export const DEFAULT_PAGINATION_OPTIONS = [10, 20, 50]
